export const environment = {
  production: true,
  // path: '',
  stripeKey:
    'pk_live_51KuNqUKyIftxmaaOf48CV6tcoFctSkGFMXIdvPC3dwM3JATmyaQ13qTXgoLHRjHe0IlKUFf4QZJrLgK1T1vFLIj200xvaJJl1H',
  urlStripe: 'https://zalona.fr/',
};
